import { Injectable } from '@angular/core';
import { AuthService } from '../services.module/auth.service';
import { Observable } from 'rxjs';
import type { UserData } from '../../generated/api/kreditportalBackendAPI.schemas';
import { UserApiService } from '../../generated/api/user/user.service';

@Injectable({ providedIn: 'root' })
export class UserService {

    constructor(
        private readonly authService: AuthService,
        private readonly userApiService: UserApiService
    ) {
    }

    public getCurrentUserData(): Observable<UserData> {
        const userId = this.authService.getUserId();

        return this.userApiService.getUserData(userId);
    }


}
